import { PayloadAction } from "@reduxjs/toolkit";

import {
  createFilterState,
  initialListFilters,
  initialListSorting,
} from "./initialState";

import type {
  FilterStateType,
  HrmsType,
  RecruitmentListUIStateType,
} from "@/redux/hrms/hrmsTypes";

export const hrmsReducer = {
  resetHrmsError: (state: HrmsType) => {
    state.error = null;
  },
  resetHrmsSuccess: (state: HrmsType) => {
    state.success = null;
  },
  resetHrmsFetching: (state: HrmsType) => {
    state.fetching = false;
  },
  resetHrmsMessage: (state: HrmsType) => {
    state.message = "";
  },
  resetHrmsStatusCode: (state: HrmsType) => {
    state.statusCode = null;
  },
  resetOpenPoisitionList: (state: HrmsType) => {
    state.openPoisitionList = [];
  },
  resetOpenPositionTotalCount: (state: HrmsType) => {
    state.openPositionTotalCount = 0;
  },
  resetRecruitmentTrackerList: (state: HrmsType) => {
    state.recruitmentTrackerList = [];
  },
  resetRecruitmentTrackerTotalCount: (state: HrmsType) => {
    state.recruitmentTrackerTotalCount = 0;
  },
  resetSingleRecruitmentTrackerList: (state: HrmsType) => {
    state.singleRecruitmentTrackerList = null;
  },
  resetUniqueCheckFetching: (state: HrmsType) => {
    state.uniqueCheckFetching = false;
  },
  resetUniqueCheckMessage: (state: HrmsType) => {
    state.uniqueCheckMessage = "";
  },
  resetApprovalList: (state: HrmsType) => {
    state.approvalList = [];
  },
  resetRecruitmentTrackerStageCountList: (state: HrmsType) => {
    state.recruitmentTrackerStageCount = [];
  },
  resetHrmsBulkUpload: (state: HrmsType) => {
    state.hrmsBulkUploadData = {};
  },
  resetBulkUploadHistoryCount: (state: HrmsType) => {
    state.bulkUploadHistoryCount = 0;
  },
  resetBulkUploadHistoryData: (state: HrmsType) => {
    state.bulkUploadHistoryData = [];
  },
  resetResignationListData: (state: HrmsType) => {
    state.resignationListData = [];
  },
  resetResignationListTotalCount: (state: HrmsType) => {
    state.resignationListTotalCount = 0;
  },
  resetWeightedAverageReportList: (state: HrmsType) => {
    state.weightedAverageReportList = [];
  },
  resetWeightedAverageReportTotalCount: (state: HrmsType) => {
    state.weightedAverageReportTotalCount = 0;
  },
  setRecruitmentSort(
    state: HrmsType,
    action: { payload: RecruitmentListUIStateType["sortBy"] }
  ) {
    state.recruitmentListUI.sortBy = action.payload;
  },

  resetRecruitmentSortingUI(state: HrmsType) {
    state.recruitmentListUI.sortBy = initialListSorting;
  },

  updateDraftFilter<K extends keyof FilterStateType>(
    state: HrmsType,
    action: PayloadAction<{ key: K; value: FilterStateType[K] }>
  ) {
    state.recruitmentListUI.filters.draft[action.payload.key] =
      action.payload.value;
  },

  applyFilters(state: HrmsType) {
    state.recruitmentListUI.filters.applied = {
      ...state.recruitmentListUI.filters.draft,
    };
  },

  resetDraft(state: HrmsType) {
    state.recruitmentListUI.filters.draft = {
      ...state.recruitmentListUI.filters.applied,
    };
  },
  resetAllFilters(state: HrmsType) {
    state.recruitmentListUI.filters.draft = createFilterState();
    state.recruitmentListUI.filters.applied = createFilterState();
  },

  syncDraftWithApplied(state: HrmsType) {
    if (!state.recruitmentListUI?.filters?.applied) {
      state.recruitmentListUI = {
        sortBy: initialListSorting,
        filters: initialListFilters,
        searchTerm: state.recruitmentListUI?.searchTerm ?? "",
      };
      return;
    }
    state.recruitmentListUI.filters.draft = {
      ...state.recruitmentListUI.filters.applied,
    };
  },

  setRecruitmentSearchTerm(state: HrmsType, action: PayloadAction<string>) {
    state.recruitmentListUI.searchTerm = action.payload;
  },

  resetRecruitmentSearchTerm(state: HrmsType) {
    state.recruitmentListUI.searchTerm = "";
  },
  setScrollPosition(state: HrmsType, action: PayloadAction<{ top: number }>) {
    state.scroll.top = action.payload.top;
  },
  resetScroll(state: HrmsType) {
    state.scroll.top = 0;
  },
  setActiveRecruitmentTab(state: HrmsType, action: PayloadAction<string>) {
    state.activeRecruitmentTab = action.payload;
  },
};
